import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL} from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions,changeDateFormat } from "../../../../Custom/Custom";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { generateExcelASITable1,generateExcelASITable1For2017 } from "../../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel";
import messages from '../../../../assets/Messages.json';
import asiTitle from '../../../../asi.json';


const Table1Report = () => {
  const [year,setYear]=useState([]);  
  const [yearName, setYearName] = useState("");
  const [tableReportData, setTableReportData] = useState([]);
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });

  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // const decode_token = getUserClaimsForUi();
  // const token = decode_token;
  // const config = getAuthHeaders();
  


  const storedLanguage = localStorage.getItem('language');

  

  //get Years 
  const getSurveyYears=async()=>{
    showLoading(true)
       try {
          const response = await axios.get(`${API_URL}api/asi/surveyYearList`, config);
          const allYear = response.data;
          if (allYear.status) {
              setYear(allYear.data.surveyYearList.reverse())
              showLoading(false);
          }
    } catch (error) {
       console.error(error);
       showLoading(false);
    }finally{
       showLoading(false);
    }
  
  }


  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
    getSurveyYears()
  }, []);

  const handleDropdownChange = (e) => {
    setYearName(e.target.value);
  };

  const downloadStaticTable1Xlsx = async () => {
    const fileUrl = `pdf/ASI_Table1.xlsx`;
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error("File not found");
      }
      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = "ASI_Table1.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error(error);
      toast.error("File not found", messages.COLOR_RED);
    } finally {
      showLoading(false);
    }
  };

  const handleGenerateExcel = () => {
    if (!yearName) {
      toast.error("Please select a Survey Year", messages.COLOR_RED);
      return;
    }

    showLoading(true);
    // Prepare payload
    const payload = {
      survey_year: yearName,
    };
    if (String(yearName) === "2023") {
      downloadStaticTable1Xlsx();
      return false;
    }

    // POST request to API
    axios
        .post(`${API_URL}api/asi/reports/HQReports/asigetTable1Report`, payload, config)
        .then((response) => {
            // Handle success and generate the Excel file directly
            const table1Report = response.data.data.asigetTable1DSLReportdata;

            if (!table1Report || table1Report.length === 0) {
              toast.error("Data not found",messages.COLOR_RED);
              showLoading(false);
              return;
            }
   
            if(yearName==="2013"){

              downloadExcelReprt(table1Report,yearName)
              return false;
            }





            let excelFileName = 'ASI_Table1';
            let firstRowMergeCells = "A1:S1";
            let secondRowMergeCells = "A2:S2";
            let thirdRowMergeCells = "A3:S3";

                // Update the merge cells and columns based on the selected year
            if (yearName === "2017") {
              firstRowMergeCells = "A1:AJ1";
              secondRowMergeCells = "A2:AJ2";
              thirdRowMergeCells = "A3:AJ3";
            } else if (String(yearName) === "2023") {
              firstRowMergeCells = "A1:AH1";
              secondRowMergeCells = "A2:AH2";
              thirdRowMergeCells = "A3:AH3";
            }

            const excelObjectData = {
              fileName: excelFileName,
              reportType: excelFileName,
              fileType: 'xlsx',
              sheetName: "ASI_Table1",
              firstRowMergeCells: firstRowMergeCells,
              firstRowExportData: 'सारिणी -१',
              firstRowCellNumber: 15,
              secondRowMergeCells: secondRowMergeCells,
              secondRowText: `वार्षिक उद्योग सर्वेक्षण ${yearName}`,
              yearName:yearName,
              thirdRowMergeCells: thirdRowMergeCells,
              thirdRowText: 'उत्तर प्रदेश के विभिन्न उद्योगों में लगी विनियोजित पूँजी , आगत, निर्गत , उत्पादन एवं शुद्ध आवर्धित मूल्य आदि का विवरण ',

            };
 // Map the data dynamically
 const numOrZero = (v) =>
   v === null || v === undefined || v === "" ? 0 : v;

 const transformedData = table1Report.map(item => {
  if (yearName === "2017") {
      return [
        item.division_code || '',
          item.district_code || '',
          item.nicCodePerframe || '',
          item.registered || 0,
          item.totalEstimated  === "" || item.totalEstimated  === null ? '0' : item.totalEstimated,
          item.totalWorking || 0,
          item.fixedCapital || 0,
          item.physicalWorkingCapital || 0,
          item.workingCapital || 0,
          item.investedCapital || 0,
          item.grossValueofadditionstofixedCapital || 0,
          item.rentPaid || 0,
          item.outstandingLoan || 0,
          item.interestPaid || 0,
          item.rentReceived || 0,
          item.interestReceived || 0,
          item.grossValueofPM || 0,
          item.valueofProductsByProducts || 0,
          item.otherOutput || 0,
          item.tatalOutput || 0,
          item.fuelsConsumed || 0,
          item.materialsConsumedforManufacturing || 0,
          item.otherInput1 || 0,
          item.tatalOutput1 || 0,
          item.gva || 0,
          item.depreciation ?? item.Depreciation ?? 0,
          item.nva || 0,
          item.netFixedCapitalFormationNFCF || 0,
          item.grossFixedCapitalFormationGFCF || 0,
          item.materialsFuelsetc || 0,
          item.semiFinishedGoods || 0,
          item.finishedGoods || 0,
          item.total || 0,
          item.grossCapitalFormation || 0,
          item.netincome ?? item.Netincome ?? item.NetIncome ?? item.netIncome ?? 0,
          item.profit || 0,
      ];
  } else if (String(yearName) === "2023") {
      return [
        item.nicCodePerframe ?? "",
        numOrZero(item.registered ?? item.No_Of_Factories),
        numOrZero(item.totalWorking ?? item.Factories_In_operation),
        numOrZero(item.totalEstimated ?? item.estimated),
        numOrZero(item.fixedCapital),
        numOrZero(item.physicalWorkingCapital),
        numOrZero(item.workingCapital),
        numOrZero(item.investedCapital),
        numOrZero(item.grossValueofadditionstofixedCapital),
        numOrZero(item.rentPaid ?? item.RentPaid),
        numOrZero(item.outstandingLoan ?? item.Outstanding_Loan),
        numOrZero(item.interestPaid ?? item.Interestpaid),
        numOrZero(item.rentReceived ?? item.Rentreceived),
        numOrZero(item.interestReceived ?? item.InterestReceived),
        numOrZero(item.grossValueofPM ?? item.GrossValueofPM),
        numOrZero(
          item.valueofProductsByProducts ?? item.ValueofProductsAndByProducts
        ),
        numOrZero(item.otherOutput ?? item.OtherOutput),
        numOrZero(item.tatalOutput ?? item.TotalOutput),
        numOrZero(item.fuelsConsumed ?? item.Fuelsconsumed),
        numOrZero(
          item.materialsConsumedforManufacturing ??
            item.MaterialsConsumedForManufacturing
        ),
        numOrZero(item.otherInput1 ?? item.OtherInput),
        numOrZero(item.tatalOutput1 ?? item.TotalInput),
        numOrZero(item.gva ?? item.GVA),
        numOrZero(item.depreciation ?? item.Depreciation),
        numOrZero(item.nva ?? item.NVA),
        numOrZero(
          item.netFixedCapitalFormationNFCF ?? item.NetFixedCapitalFormation
        ),
        numOrZero(
          item.grossFixedCapitalFormationGFCF ?? item.GrossFixedCapitalFormation
        ),
        numOrZero(item.materialsFuelsetc ?? item.MaterialsFuelsEtc),
        numOrZero(item.semiFinishedGoods ?? item.SemiFinishedGoods),
        numOrZero(item.finishedGoods ?? item.FinishedGoods),
        numOrZero(item.total ?? item.Total),
        numOrZero(item.grossCapitalFormation ?? item.GrossCapitalFormation),
        numOrZero(
          item.netincome ?? item.Netincome ?? item.NetIncome ?? item.netIncome
        ),
        numOrZero(item.profit ?? item.Profit),
      ];
  } else{
     return [
        item.nicCodePerframe,
        item.registered ||item.No_Of_Factories,
        item.totalWorking ?? item.Factories_In_operation ?? '0',
        item.totalEstimated ?? '0',
        item.fixedCapital ?? '0',
        item.physicalWorkingCapital?? '0',
        item.workingCapital ?? '0',
        item.investedCapital ?? '0',
        item.grossValueofadditionstofixedCapital ?? '0',
        item.rentPaid ?? item.RentPaid ?? '0',
        item.outstandingLoan ?? item.Outstanding_Loan ?? '0',
        item.interestPaid ?? item.Interestpaid ?? '0',
        item.rentReceived ?? item.Rentreceived ?? '0',
        item.interestReceived ?? item.InterestReceived ?? '0',
        item.grossValueofPM ?? item.GrossValueofPM ?? '0',
        item.valueofProductsByProducts ?? item.ValueofProductsAndByProducts ?? '0',
        item.otherOutput ?? item.OtherOutput ?? '0',
        item.tatalOutput ?? item.TotalOutput ?? '0',
        item.fuelsConsumed ?? item.Fuelsconsumed ?? '0',
    ];
}
});

            excelObjectData.excelRowData = transformedData;

            generateExcelASITable1(excelObjectData);

            showLoading(false);
        })
        .catch((error) => {
            console.error('API Error:', error);
            showLoading(false);
        });
};



const downloadExcelReprt=(allData,year)=>{

  const transformedData = allData.map(item => {
    return [
      item.majorGroupName===null?'0':item.majorGroupName,
      item.sumofregistor,
      item.sumoftotalWorking,
      item.sumoftotalEstimated,
      item.sum_col_4,
      item.sum_col_5,
      item.sum_col_6,
      item.sum_col_7,
      item.sum_col_8,
      item.sum_col_9,
      item.sum_col_10,
      item.sum_col_11,
      item.sum_col_12,
      item.sum_col_13,
      item.sum_col_14,
      item.sum_col_15,
      item.sum_col_16,
      item.sum_col_17,
      item.sum_col_18,
    ];


  });

  const excelObjectData = {
    fileName: 'ASI_Table1',
    fileType: 'xls',
    sheetName: "ASI_Table1",
    firstRowMergeCells: 'A1:S1',
    firstRowExportData: changeDateFormat(new Date()),
    secondRowMergeCells: 'A2:S2',
    secondRowText:  'सारिणी -१',
    thirdRowMergeCells: 'A3:S3',
    thirdRowText:  `वार्षिक उद्योग सर्वेक्षण ${year}`,
    fourthRowMergeCells: 'A4:S4',
    forthRowText:  `उत्तर प्रदेश के विभिन्न उद्योगों में लगी विनियोजित पूँजी , आगत, निर्गत , उत्पादन एवं शुद्ध आवर्धित मूल्य आदि का विवरण`,
    fifthRowText:  ['उत्तर प्रदेश','मूल्य हज़ार रुपए तथा अन्य संख्या में','','','','','','','','','','','','','','','','',''],
    sixRowText:  ['उद्योग संकेत (4 अंकीय ) (एन.आई.सी. 2008 )','कारखानों की संख्या','','',
      'स्थायी पूँजी','भौतिक कार्यशील पूँजी','विनियोजित  पूँजी','उपभुक्त सामग्री ',
      'कुल आगत','कुल निर्गत','उत्पादन का मूल्य','सकल आवर्धित मूल्य','मूल्य ह्रास ',
      'शुद्ध आवर्धित मूल्य','शुद्ध स्थायी पूँजी विनिर्माण','सकल  स्थायी पूँजी विनिर्माण','शुद्ध आय','लाभ',
      'सकल पूँजी निर्माण'],
    seventhRow:['','पंजीकृत','कार्यरत','अनुमानित','','','','','','','','','','','','','','','','',''],
    excelRowData:transformedData
 };
 showLoading(false);

 generateExcelASITable1For2017(excelObjectData);

}


  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
            <h4 className="page_heading">
            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.TABLE_ONE_REPORT : asiTitle.en.TABLE_ONE_REPORT }} />
            </h4>
             <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">
                  {storedLanguage === 'hi' ? asiTitle.hi.SURVEY_YAER : asiTitle.en.SURVEY_YAER}
                    </label>
                  <select
                    name="year_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearName}
                  >
                    <option value="" disabled>
                      Select Year
                    </option>
                    {year
                      .sort((a, b) => b - a) 
                      .map((yearName, index) => (
                        <option key={index} value={yearName}>
                          {yearName}-{(parseInt(yearName) + 1).toString().slice(2)}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-2 col-lg-12 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default Table1Report